import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { adminApi } from '@/apis/api';
import { getItem, removeItem } from '@/common/localStorage';
import { parseJwtToken } from '@/common/parseToken';

const setAuthorizationHeader = (token) => {
  adminApi.defaults.headers.common.Authorization = `Bearer ${token}`;
};

const getInitialAuthState = () => {
  const localToken = getItem('token');
  
  if (localToken !== null) {
    try {
      const token = localToken.split('Bearer ')[1];
      const { username, role, userId } = parseJwtToken(token);
      setAuthorizationHeader(token);
      
      return {
        userId,
        username,
        role,
        token: localToken,
        refreshToken: getItem('refreshToken') || '',
      };
    } catch (error) {
      removeItem('token');
      removeItem('refreshToken');
    }
  }
  
  return {
    userId: '',
    username: '',
    role: 1,
    token: '',
    refreshToken: '',
  };
};

const defaultAuthState = {
  userId: '',
  username: '',
  role: 1,
  token: '',
  refreshToken: '',
};

// SessionStorage를 사용하는 atom
export const authAtom = atomWithStorage(
  'authAtom',
  getInitialAuthState(),
  {
    getItem: (key) => {
      if (typeof window === 'undefined') return defaultAuthState;
      const value = sessionStorage.getItem(key);
      if (!value) {
        // sessionStorage 비어있을 때 localStorage 토큰에서 auth 복원 (새 탭 등)
        const restored = getInitialAuthState();
        if (restored.token) {
          sessionStorage.setItem(key, JSON.stringify(restored));
        }
        return restored;
      }
      try {
        const parsed = JSON.parse(value);
        return parsed || defaultAuthState;
      } catch (error) {
        return defaultAuthState;
      }
    },
    setItem: (key, value) => {
      if (typeof window === 'undefined') return;
      sessionStorage.setItem(key, JSON.stringify(value));
      
      // token이 변경되면 Authorization header 업데이트
      if (value?.token) {
        const token = value.token.split('Bearer ')[1];
        setAuthorizationHeader(token);
      } else {
        delete adminApi.defaults.headers.common.Authorization;
      }
      
      // token이 없으면 localStorage도 정리
      if (!value?.token) {
        removeItem('token');
        removeItem('refreshToken');
      }
    },
    removeItem: (key) => {
      if (typeof window === 'undefined') return;
      sessionStorage.removeItem(key);
      removeItem('token');
      removeItem('refreshToken');
      delete adminApi.defaults.headers.common.Authorization;
    },
  },
  { getOnInit: true }
);
